import React, { useState, useEffect } from 'react';
import PageContainer from '../components/containers/PageContainer';
import { Card, CardHeader, CardContent, IconButton, TableCell, TableRow, Tooltip, Stack, Button } from '@mui/material';
import { toast } from 'react-toastify';
import Field from '../components/ui/Field';
import CustomTable from '../components/ui/CustomTable';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ModalContainer from '../components/containers/ModalContainer';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../config/axios';

const SingleInternationalPricing = () => {
    const { id } = useParams();
    const [pricing, setPricing] = useState({});
    const [message, setMessage] = useState('');
    const [loader, setLoader] = useState('');
    const [singleWeight, setSingleWeight] = useState({});
    const navigate = useNavigate();

    const [showAddPricing, setShowAddPricing] = useState(false);

    const onCloseAddPricingModal = () => {
        setShowAddPricing(false);
    };
    const onOpenAddPricingModal = () => setShowAddPricing(true);

    const [showEditPricing, setShowEditPricing] = useState(false);

    const onCloseEditPricingModal = () => {
        setShowEditPricing(false);
    };
    const onOpenEditPricingModal = () => setShowEditPricing(true);

    const getPricing = async () => {
        await api
            .get('/international-labeltype/read/' + id)
            .then((res) => {
                setPricing(res.data.labelType);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(() => {
        getPricing();
    }, [id]);

    const addWeight = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            fromWeight: e.target.fromWeight.value,
            toWeight: e.target.toWeight.value,
            price: e.target.price.value,
        };

        await api
            .post('/international-labeltype/addweight/' + id, data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getPricing();
                onCloseAddPricingModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    const deleteWeight = async (fromWeight, toWeight) => {
        const data = {
            fromWeight: fromWeight,
            toWeight: toWeight,
        };

        await api
            .post('/international-labeltype/deleteWeight/' + id, data)
            .then((res) => {
                toast.success(res.data.message);
                getPricing();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    const updateWeight = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            price_id: singleWeight._id,
            fromWeight: e.target.fromWeight.value,
            toWeight: e.target.toWeight.value,
            price: e.target.price.value,
        };

        await api
            .put('/international-labeltype/updateWeight/' + id, data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getPricing();
                onCloseEditPricingModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };
    return (
        <PageContainer
            title="Custom International Pricing"
            desc={'Label Type : ' + pricing.name}
            end={
                <Button onClick={onOpenAddPricingModal} variant="contained">
                    Add Weight
                </Button>
            }>
            <CustomTable sx={{ mt: 2 }} fields={['#', 'FROM WEIGHT', 'TO WEIGHT', 'PRICE', 'ACTION']} dense={false}>
                {pricing.prices?.map((price, index) => (
                    <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{price.fromWeight}</TableCell>
                        <TableCell>{price.toWeight}</TableCell>
                        <TableCell>${price.price}</TableCell>
                        <TableCell>
                            <Stack direction="row">
                                <IconButton
                                    onClick={() => {
                                        setSingleWeight(price);
                                        onOpenEditPricingModal();
                                    }}>
                                    <ModeEditOutlineOutlinedIcon fontSize="small" />
                                </IconButton>
                                <IconButton onClick={() => deleteWeight(price.fromWeight, price.toWeight)}>
                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
            {/* create Pricing */}

            <ModalContainer open={showAddPricing} onClose={onCloseAddPricingModal} title="Add weight" hideActions>
                {message}
                <form onSubmit={addWeight}>
                    <div className="form-group mb-3">
                        <label>From Weight</label>
                        <input type="number" className="form-control" name="fromWeight" required />
                    </div>
                    <div className="form-group mb-3">
                        <label>To Weight</label>
                        <input type="number" className="form-control" name="toWeight" required />
                    </div>

                    <div className="form-group mb-3">
                        <label>Price</label>
                        <input type="tel" className="form-control" name="price" required />
                    </div>

                    <div className="d-flex mt-2 justify-content-end ">
                        <button type="button" className="btn btn-white me-3" data-bs-dismiss="modal">
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary">
                            Add {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* Edit Pricing */}
            <ModalContainer open={showEditPricing} onClose={onCloseEditPricingModal} hideActions title="Edit weight">
                {message}
                <form onSubmit={updateWeight}>
                    <div className="form-group mb-3">
                        <label>From Weight</label>
                        <input
                            type="number"
                            className="form-control"
                            name="fromWeight"
                            required
                            defaultValue={singleWeight.fromWeight}
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label>To Weight</label>
                        <input
                            type="number"
                            className="form-control"
                            name="toWeight"
                            required
                            defaultValue={singleWeight.toWeight}
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Price</label>
                        <input
                            type="tel"
                            className="form-control"
                            name="price"
                            defaultValue={singleWeight.price}
                            required
                        />
                    </div>

                    <div className="d-flex mt-2 justify-content-end ">
                        <button type="button" className="btn btn-white me-3" data-bs-dismiss="modal">
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary">
                            Update {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>
        </PageContainer>
    );
};

export default SingleInternationalPricing;
